import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { initializeThemeAtom } from "../../stores/theme-store.ts";

export function ThemeSync() {
	const initializeTheme = useSetAtom(initializeThemeAtom);

	useEffect(() => {
		initializeTheme();
	}, [initializeTheme]);

	return null;
}
